const hasModule = (store, moduleName) => {
  return store && store.hasModule(moduleName);
};

export const NotificationMixin = {
  computed: {
    notifications: function() {
      if (!hasModule(this.$store, 'notification')) {
        throw new Error('Notification module required');
      }

      return this.$store.getters['notification/notifications'];
    },
  },
  methods: {
    notifySuccess: function(message, options) {
      if (!hasModule(this.$store, 'notification')) {
        throw new Error('Notification module required');
      }

      this.$store.dispatch('notification/notifySuccess', { message, options });
    },
    notifyFailure: function(message, options) {
      if (!hasModule(this.$store, 'notification')) {
        throw new Error('Notification module required');
      }

      this.$store.dispatch('notification/notifyFailure', { message, options });
    },
  },
};
